import type { ErrorSpec } from '../../types/analyticsConstantsTypes';

type Options = {
  error?: string | null;
  whitelist: ErrorSpec[];
  metadata?: Record<string, any>;
};

/**
 * method that identifies if an error text can be displayed to the end user,
 * and returns a shortened message for the error if so
 */
export const getWhitelistedErrorMessage = (options: Options) => {
  const { error, whitelist, metadata } = options;
  if (!error) {
    return;
  }

  const matchedError = whitelist.find((whitelistErrorSpecification) => {
    const { regex } = whitelistErrorSpecification;
    return regex.test(error);
  });

  if (!matchedError) {
    return;
  }

  if (matchedError.buildErrorMessage) {
    try {
      const message = matchedError.buildErrorMessage(error, metadata);
      if (message) {
        return message;
      }
    } catch (err) {}
  }

  return matchedError.shortErrorMessage;
};
